import { environment } from 'src/environments/environment';

const PREFIX = '[ParaLMS]';
const LS_KEY = 'debugParaLms';

/**
 * Debug logging for the PARA LMS slideout (URL resolution, iframe, API data).
 *
 * **Default:** logs in every non-production build (`npm start` / dev), regardless of `environment.enableDebug`.
 *
 * **Overrides (DevTools console):**
 * - `localStorage.setItem('debugParaLms', '0')` — turn off in dev
 * - `localStorage.setItem('debugParaLms', '1')` — force on (e.g. production build)
 * - `localStorage.removeItem('debugParaLms')` — back to default (on in dev, off in prod)
 */
export function debugParaLms(message: string, data?: unknown): void {
	let enabled = false;
	try {
		const flag = typeof localStorage !== 'undefined' ? localStorage.getItem(LS_KEY) : null;
		if (flag === '1') {
			enabled = true;
		} else if (flag === '0') {
			enabled = false;
		} else {
			enabled = !environment.production;
		}
	} catch {
		enabled = !environment.production;
	}
	if (!enabled) {
		return;
	}
	if (data !== undefined) {
		console.log(`${PREFIX} ${message}`, data);
	} else {
		console.log(`${PREFIX} ${message}`);
	}
}
